import { d as f } from "./index60.js";
function c(e, a) {
  var r = new f.Facade(e, a);
  return e.type === "track" && (r = new f.Track(e, a)), e.type === "identify" && (r = new f.Identify(e, a)), e.type === "page" && (r = new f.Page(e, a)), e.type === "alias" && (r = new f.Alias(e, a)), e.type === "group" && (r = new f.Group(e, a)), e.type === "screen" && (r = new f.Screen(e, a)), Object.defineProperty(r, "obj", {
    value: e,
    writable: !0
  }), r;
}
export {
  c as toFacade
};
//# sourceMappingURL=index51.js.map
